import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'tela-cadastro',
	templateUrl: './tela-cadastro.component.html',
	styleUrls: ['./tela-cadastro.component.scss'],
})
export class TelaCadastroComponent implements OnInit {

	@Input('side') side: 'left' | 'right';
	@Input('fundo') fundo: 'login' | 'recuperar-senha' | 'redefinir-senha' | 'criar-conta' | 'confirmacao';
	@Input('video') video: 'show' | 'hide';
	bd = '';
	bgs = {
		'login':'../../../assets/img/login//bg-login.jpg',
		'recuperar-senha':'../../../assets/img/login//bg-recuperar-senha.jpg',
		'redefinir-senha':'../../../assets/img/login//bg-redefinir-senha.jpg',
		'criar-conta':'../../../assets/img/login//fundo_colorido.png',
		'confirmacao':'../../../assets/img/login//fundo_colorido.png'
	}
	constructor(
		private domSanitizer: DomSanitizer,
	) { }
	
	rota:any;
	linkvideo:any;

	ngOnInit() {		
		this.montaLink();
	}

	montaLink() {
		let link = 'https://www.youtube.com/watch?v=PO8juT1UcrI'
		let regex = link.match(/v=(.*?)&|v=(.*)/);
		let linkEmbed = "https://www.youtube.com/embed/" + regex[2];
		this.linkvideo = this.domSanitizer.bypassSecurityTrustResourceUrl(linkEmbed);

	}


}
